

















import { Component, Vue } from 'vue-property-decorator';

import { loginService, homeService } from '@/services';
import { ResponseCodeEnum } from '@/models';

// @ts-ignore
import { HeaderDropdown } from '@coreui/vue';

@Component({
  components: {
    HeaderDropdown,
  },
})
export default class AppHeaderDropdown extends Vue {
  private static readonly PROFILE_TEST = 'test';
  private static readonly PROFILE_STAGING = 'staging';
  private static readonly PROFILE_PRODUCTION = 'production';
  private showLanguageDropdown = true;

  private created() {
    homeService.getServerProfile()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          const profiles: string[] = res.data.data;
          if (profiles.includes(AppHeaderDropdown.PROFILE_TEST)
            || profiles.includes(AppHeaderDropdown.PROFILE_STAGING)
            || profiles.includes(AppHeaderDropdown.PROFILE_PRODUCTION)) {
            this.showLanguageDropdown = false;
            this.changeLang('jp');
          }
        }
      });
  }

  private changeLang(language: string) {
    this.$store.dispatch('setLang', language);
    this.$store.dispatch('setLocale', language);
  }

  private logout() {
    this.$store.dispatch('setUser', null);
    loginService.logout()
      .then((isSuccess) => {
        if (isSuccess) {
          this.$router.push('/login');
        }
      });
  }

}
